import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import Conversations from '../components/conversations/conversations';
import RecordingConversation from '../components/controls/RecordingConversation';
import MessagesList from '../components/messages/MessagesList';
import Summary from '../components/summary/summary.jsx';
import WelcomePage from '../components/welcome/welcome.jsx';

const ConversationsPage = ({
  recording,
  messages,
  summary,
  summaryId,
  audioFilename,
  generatingSummary,
  wsOpen,
  showControls,
  selectedConversation,
  language,
  selectedPrompt,
  promptTemplates,
  audioReady,
  startNewConversation,
  startRecording,
  stopRecording,
  setLanguage,
  setSelectedPrompt,
  setSelectedConversation,
  setShowControls,
  wordCount,
  recordingDuration,
  setSummary,
  setSummaryId,
  setGeneratingSummary,
  setPromptTemplates,
  setMessages,
  setAudioFilename,
  setAudioReady,
  setWordCount,
  setRecordingDuration,
  showTranscriberErrorMessage,
  setShowTranscriberErrorMessage,
  showNewConversationErrorMessage,
  setShowNewConversationErrorMessage,
  triggerUpdateConversationId,
}) => {
  // Reset recording data when conversation changes
  useEffect(() => {
    if (selectedConversation && !selectedConversation.short_summary){
      // Reset word count and recording duration for new conversations
      setWordCount(0);
      setRecordingDuration(0);
      setMessages([]);
    }
  }, [selectedConversation, setWordCount, setRecordingDuration, setMessages]);

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        height: '100vh', // Use viewport height instead of percentage
        overflow: 'hidden', // Prevent the entire page from scrolling
        width: '100%',
      }}
    >
      {/* Conversations panel */}
      <Box 
        sx={{ 
          width: {xs: '100%', md: '440px'},
          height: '100%', 
          borderRight: '1px solid #e0e0e0',
          overflow: 'hidden', // Prevent this container from scrolling
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Conversations
          selectedConversation={selectedConversation}
          setSelectedConversation={setSelectedConversation}
          startNewConversation={startNewConversation}
          setShowControls={setShowControls}
          recording={recording}
          setMessages={setMessages}
          setSummary={setSummary}
          setSummaryId={setSummaryId}
          setAudioFilename={setAudioFilename}
          setPromptTemplates={setPromptTemplates}
          setSelectedPrompt={setSelectedPrompt}
          setLanguage={setLanguage}
          setAudioReady={setAudioReady}
          showTranscriberErrorMessage={showTranscriberErrorMessage}
          setShowTranscriberErrorMessage={setShowTranscriberErrorMessage}
          showNewConversationErrorMessage={showNewConversationErrorMessage}
          setShowNewConversationErrorMessage={setShowNewConversationErrorMessage}
          triggerUpdateConversationId={triggerUpdateConversationId}
        />
      </Box>

      {/* Main content area with flex-grow */}
      <Box 
        sx={{ 
          flexGrow: 1, 
          height: '100%',
          overflow: 'hidden', // Prevent this container from scrolling
          display: 'flex', 
          flexDirection: 'column'
        }}
      >
        {showControls ? (
          <>
            <RecordingConversation
              recording={recording}
              startRecording={startRecording}
              stopRecording={stopRecording}
              wsOpen={wsOpen}
              language={language}
              setLanguage={setLanguage}
              selectedPrompt={selectedPrompt}
              setSelectedPrompt={setSelectedPrompt}
              promptTemplates={promptTemplates}
              audioReady={audioReady}
              wordCount={wordCount}
              recordingDuration={recordingDuration}
              selectedConversation={selectedConversation}
              messages={messages}
            />
          </>
        ) : (
          <>
          {selectedConversation ? (
            <Box sx={{ height: '100%', overflow: 'hidden', display: {xs: 'none', md: 'block'} }}>
              <Summary
                summary={summary || ''}
                setSummary={setSummary}
                summaryId={summaryId}
                setSummaryId={setSummaryId}
                setGeneratingSummary={setGeneratingSummary}
                conversation={selectedConversation}
                audioFilename={audioFilename}
                selectedPrompt={selectedPrompt}
                setSelectedPrompt={setSelectedPrompt}
                promptTemplates={promptTemplates}
                startRecording={startRecording}
                stopRecording={stopRecording}
                recording={recording}
                audioReady={audioReady}
                recordingDuration={recordingDuration}
                wordCount={wordCount}
                messages={messages}
                generatingSummary={generatingSummary}
              />
            </Box>
          ) : (
            <WelcomePage
            />
          )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default ConversationsPage; 